import { render, staticRenderFns } from "./NumberKeyboard.vue?vue&type=template&id=07fc3396"
import script from "./NumberKeyboard.vue?vue&type=script&lang=js"
export * from "./NumberKeyboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports